module.exports = "<img *ngIf=!isPin (click)=pin() src=\"../../../assets/img/pin.svg\">\n<img *ngIf=isPin (click)=pin() src=\"../../../assets/img/pinblue.svg\">"